import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { TranslateModule } from "@ngx-translate/core";
import { Quadrant } from "libs/questionaire/src/lib/orcadent/models/questionnaire-orcadent.model";

enum AnswerOption {
	DISTALIZE = "distalize",
	MESIALIZE = "mesialize",
	COMPRESS = "compress",
	EXPAND = "expand",
}

enum MovementTypeFormGroupName {
	DISTALIZE_MESIALIZE = 'distalize_mesialize',
	COMPRESS_EXPAND = 'compress_expand',
}

@Component({
	selector: "posterior-teeth-form",
	standalone: true,
	imports: [
		CommonModule,
		MatRadioModule,
		MatFormFieldModule,
		MatInputModule,
		TranslateModule,
		ReactiveFormsModule
	],
	templateUrl: "./posteriorTeethForm.component.html",
	styleUrl: "./posteriorTeethForm.component.scss"
})
export class PosteriorTeethFormComponent implements OnInit{

	@Input() parentForm: FormGroup;
	@Input() nestedFormGroupName: string;
	@Input() quadrantFormGroupName: Quadrant;

	AnswerOption = AnswerOption;
	MovementTypeFormGroupName = MovementTypeFormGroupName;

	distalizeGroup: FormGroup;
	compressGroup: FormGroup;

	formGroups: FormGroup[];

	ngOnInit(): void {
		this.distalizeGroup = this.parentForm.get(`${this.nestedFormGroupName}.${this.quadrantFormGroupName}.${MovementTypeFormGroupName.DISTALIZE_MESIALIZE}`) as FormGroup;
		this.compressGroup = this.parentForm.get(`${this.nestedFormGroupName}.${this.quadrantFormGroupName}.${MovementTypeFormGroupName.COMPRESS_EXPAND}`) as FormGroup;

		this.formGroups = [this.distalizeGroup, this.compressGroup];

		this.formGroups.forEach( group => {
			const textFormControl = group.get('text');
			const optionFormControl = group.get('option');
			//set en-/disabled state depending on value (e.g. should not be disabled when form is prefilled)
			if(textFormControl.value || optionFormControl.value){
				textFormControl.enable({emitEvent: false});
			}else{
				textFormControl.disable({emitEvent: false});
			}

			optionFormControl.valueChanges.subscribe((value) =>{
				if ( value ){
					textFormControl?.enable({emitEvent: false});
				}else{
					textFormControl?.disable({emitEvent: false});
				}
			})
		} );
	}

	onClick( answerOption: AnswerOption, movementTypeFormGroupName: MovementTypeFormGroupName){
		const formControl =  this.parentForm.get(`${this.nestedFormGroupName}.${this.quadrantFormGroupName}.${movementTypeFormGroupName}`) as FormControl;
		if (answerOption === formControl.get('option')?.value) {
			formControl.patchValue({ option: null, text: null });
		}
	}
}
